import React, { Component } from "react";
import "./styles.css";
// import G from "../../../js/globals";
import E from "../../../js/events";
import Divider      from "../../prefabs/divider/view";
import InputCounter from "../../widgets/input-counter/view";
import InputToggle  from "../../widgets/input-toggle/view";
// import imgChar      from "./img/cake_c.png";

class SectionCake extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.handleCakesCount    = this.handleCakesCount.bind(this);
    this.handleOwnCakeToggle = this.handleOwnCakeToggle.bind(this);
    this.handleOptionalInclusionsNoHostCount = this.handleOptionalInclusionsNoHostCount.bind(this);
  }



  // ===============================================================================================
  handleCakesCount(amount) {
    this.props.handleAppEvent(E.events.CAKE_MOD_CAKE, amount);
  }



  // ===============================================================================================
  handleOwnCakeToggle(toggle) {
    this.props.handleAppEvent(E.events.CAKE_MOD_BYO, toggle);
  }



  // ===============================================================================================
  handleOptionalInclusionsNoHostCount(product_name, amount) {
    // console.log("handleOptionalInclusionsNoHostCount", product_name, amount);
    this.props.handleAppEvent(E.events.CAKE_MOD_OPTIONAL_INCLUSIONS_NO_HOST, {product_name, amount});
  }



  // ===============================================================================================
  render() {

    let selLocation = this.props.selLocation;
    // If we have location specific products, use them, otherwise use the default products
    let products = (selLocation && selLocation.products) || this.props.products;

    let costCake = (products['ice_cream_cake']) ? products['ice_cream_cake'].price : 0;

    let optionalNoHostProducts = [];
    let optionalNoHostProductsPrice = 0;
    if (this.props.eventType === "no-host") {
      for (let key in products) {
        if (products[key].optional_inclusion_no_host === 1) {
          const product = products[key];
          optionalNoHostProductsPrice = product.price;
          optionalNoHostProducts.push(
            <React.Fragment key={key}>
              <Divider type="default"/>
              <div className={"inclusions-item " + key}>
                <h3>{product.view && product.view.title}</h3>
                <p>{product.view && product.view.description}</p>
                {product.view && product.view.details && Array.isArray(product.view.details) ? (
                  <ul>
                    {product.view.details.map((detail, index) => (
                      <li key={`${key}-detail-${index}`}>{detail}</li>
                    ))}
                  </ul>
                ) : null}
                <InputCounter
                  label={`$${(optionalNoHostProductsPrice / 100).toFixed(2)} each`}
                  amount={ this.props.numOptionalInclusionsNoHost[key] !== undefined ? this.props.numOptionalInclusionsNoHost[key] : 0 }
                  min={0}
                  max={999}
                  handleChange={(amount) => this.handleOptionalInclusionsNoHostCount(key, amount)}
                />
              </div>
            </React.Fragment>
          );
        }
      }
    }

    return (
      <div className="cont-section cont-section--offset-header cont-section--offset-footer cont-section--offset-sidebar cont-section--cake">
        <div className="cont-wrapper">
          <h1>Add ons</h1>
          <div className="inclusions-list">
            <div className="inclusions-item ice_cream_cake">

              <h3>
                Treat your party with an Ice Cream Cake
              </h3>

              <p>
                Approximately 16 servings per cake
              </p>

              <ul>
                <li> The average adult daily intake is 8,700kJ </li>
                <li> Whole cake: 5,700kJ                       </li>
                <li> Per slice/serve: 335kJ                   </li>
              </ul>

              <InputCounter
                label={"$" + (costCake / 100).toFixed(2) + "* each cake"}
                amount={this.props.numCakes}
                min={0}
                max={20}
                handleChange={this.handleCakesCount}
                // disabled={this.props.isByo === true}
                />
            </div>


            <Divider type="default"/>
            <div className="inclusions-item free_cake">

              <h3>
                Bring your own cake
              </h3>

              <p>
                Baked a treat? You're welcome to bring it along^.
              </p>

              <InputToggle
                label="Free"
                checked={this.props.isByo}
                handleChange={this.handleOwnCakeToggle}
              />
            </div>

            {optionalNoHostProducts}

          </div>
        </div>
      </div>
    );
  }

}



export default SectionCake
